import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'filters',
    path: 'locations',
    viewPath: props.viewPath,
  })

  let location = useDataValue({
    context: 'location',
    viewPath: props.viewPath,
  })

  let locations = useDataValue({
    context: 'filters',
    path: 'locations',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let shouldRemove = locations.some(({ id }) => id === location.id)
    change([
      ...locations.filter(({ id }) => id !== location.id),
      ...(shouldRemove ? [] : [location]),
    ])
  }
}

export function isChecked(locations, locationId) {
  return locations.some(({ id }) => id === locationId)
}
